<!-- <div class="input-group mb-2" >
  <div class="input-group-prepend" *ngIf="label">
      <span class="input-group-text">{{ label | translate }}</span>
  </div>
  <input class="form-control" [ngClass]="{'is-invalid' : !checkIsValid() }" type="{{ type }}" [formControl]="control" [readonly]="readonly"/>
</div> -->
<s1-input-label [label]="label">
  <input #input class="form-control {{  customClass }}" [ngClass]="{'is-invalid' : !checkIsValid() }" type="{{ type }}" [formControl]="control" [readonly]="readonly"/>
</s1-input-label>